import React, { useState, useRef, useEffect } from 'react';
import EffectPreview from './EffectPreview';
import './MenuTooltip.css';

function MenuTooltip({ title, description, imageUrl, videoUrl, effectType, isVisible, position }) {
  const [isPreviewPlaying, setIsPreviewPlaying] = useState(false);

  // Start animation when tooltip becomes visible
  useEffect(() => {
    if (isVisible && effectType) {
      setIsPreviewPlaying(true);
    } else {
      setIsPreviewPlaying(false);
    }
  }, [isVisible, effectType]);

  if (!isVisible) return null;

  return (
    <div 
      className="menu-tooltip"
      style={{
        left: `${position.x}px`,
        top: `${position.y}px`
      }}
    >
      <div className="tooltip-content">
        <h3>{title}</h3>
        <p>{description}</p>
        {effectType && (
          <div className="tooltip-preview">
            <EffectPreview 
              effectType={effectType} 
              isPlaying={isPreviewPlaying}
            />
          </div>
        )}
        {videoUrl && !effectType && (
          <div className="tooltip-gif">
            <img
              src={videoUrl}
              alt={title}
            />
          </div>
        )}
        {imageUrl && !videoUrl && !effectType && (
          <div className="tooltip-image">
            <img src={imageUrl} alt={title} />
          </div>
        )}
      </div>
    </div>
  );
}

export default MenuTooltip; 